"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const bag = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-bag` : '') + (description ? ` desc-bag` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-bag"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-bag"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_2429_1825)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 .25h.22c1.1.07 2.12.57 2.92 1.4a6.2 6.2 0 0 1 1.62 3.52h4.3a2.2 2.2 0 0 1 2.18 1.82v.23l-2 14.36c0 .19-.01.38-.06.57l-.07.21a2.16 2.16 0 0 1-1.22 1.25c-.26.1-.54.15-.83.14H4.94a2.06 2.06 0 0 1-1.58-.63 2.16 2.16 0 0 1-.6-1.54l-2-14.36a.75.75 0 0 1 0-.23c.09-.52.36-1 .76-1.33.4-.33.9-.5 1.42-.5h4.32V5a6.2 6.2 0 0 1 1.62-3.35A4.4 4.4 0 0 1 12 .25Zm9.06 6.42H2.9a.6.6 0 0 0-.42.14.7.7 0 0 0-.22.34l1.98 14.27.02.28a.7.7 0 0 0 .18.37.6.6 0 0 0 .21.14c.08.03.16.04.24.04h14.22c.08 0 .16 0 .24-.04l.11-.06a.66.66 0 0 0 .25-.31.7.7 0 0 0 .04-.28v-.14l1.99-14.27a.7.7 0 0 0-.22-.34.62.62 0 0 0-.43-.14h-.03ZM12 1.75a2.9 2.9 0 0 0-2.05.94 4.68 4.68 0 0 0-1.2 2.48h6.5c-.17-1-.6-1.86-1.19-2.47A2.9 2.9 0 0 0 12 1.75Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_2429_1825"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = bag;